function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Element } from '@klarna/ui';
import { getEditorEntryDetails } from 'features/contentful/utils/useEditorEntryDetails';
import { OMIT_SEARCH_SNIPPET_TAG } from 'features/klarnaMarketing/constants/searchSnippetTags';
import { logger } from 'framework/utils/logging';
import Components from './index';
const ComponentLoader = ({ loaderProps })=>{
    const { createEntryAttributes } = getEditorEntryDetails();
    if (!loaderProps) {
        return null;
    }
    if (typeof loaderProps === 'string') {
        return loaderProps;
    }
    const { __component, props: componentProps } = loaderProps;
    if (!__component) {
        return null;
    }
    const Component = Components[__component];
    if (!Component) {
        // todo: replace with logger, .error crashes on ssr
        logger.error(`${__component} component does not exist.
      Loader props: ${JSON.stringify(loaderProps)}`);
        return null;
    }
    if (!componentProps) {
        return /*#__PURE__*/ _jsx(Component, {});
    }
    const props = {};
    for(const key in componentProps){
        // eslint-disable-next-line no-prototype-builtins
        if (componentProps.hasOwnProperty(key)) {
            const componentProp = componentProps[key];
            const isObjectProp = componentProp && typeof componentProp === 'object';
            const hasChildComponent = isObjectProp && typeof componentProp.__component !== 'undefined';
            const hasChildComponentArray = Array.isArray(componentProp) && componentProp.find((c)=>c !== null && typeof c.__component !== 'undefined');
            props[key] = hasChildComponent ? /*#__PURE__*/ _jsx(ComponentLoader, {
                loaderProps: componentProp
            }) : hasChildComponentArray ? componentProp.filter(Boolean)// eslint-disable-next-line @eslint-react/no-array-index-key -- sibling order is stable in CMS payload
            .map((prop, index)=>/*#__PURE__*/ _jsx(ComponentLoader, {
                    loaderProps: prop
                }, index)) : componentProp;
        }
    }
    const entryId = componentProps.entryId;
    const editorAttributes = entryId ? createEntryAttributes({
        id: entryId,
        contentType: __component
    }) : null;
    const { key: listKey } = props, loadableProps = _object_without_properties(props, [
        "key"
    ]);
    const omitFromSearchSnippet = componentProps.omitFromSearchSnippet === true || Array.isArray(componentProps.tags) && componentProps.tags.includes(OMIT_SEARCH_SNIPPET_TAG);
    const rendered = /*#__PURE__*/ _jsx(Component, _object_spread({}, loadableProps, editorAttributes !== null && editorAttributes !== void 0 ? editorAttributes : {}), listKey);
    if (!omitFromSearchSnippet) {
        return rendered;
    }
    // Google honors data-nosnippet for snippet text; content stays visible on the page.
    return /*#__PURE__*/ _jsx(Element, {
        webOnlyProps: {
            'data-nosnippet': true
        },
        children: rendered
    });
};
const TemplateLoader = ({ loaderProps })=>{
    const propsArray = Array.isArray(loaderProps) ? loaderProps : [
        loaderProps
    ];
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: propsArray.map((props, index)=>// eslint-disable-next-line @eslint-react/no-array-index-key -- top-level block list has no stable id in all fixtures
            /*#__PURE__*/ _jsx(ComponentLoader, {
                loaderProps: props
            }, index))
    });
};
export default TemplateLoader;
